export default __webpack_public_path__ + "static/media/fr.0c209b8a.svg";